import { RouterLink } from '@angular/router';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'vx-uidcheck-header',
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, FormsModule],
})
export class Header {
  private authService = inject(AuthService);
  private translate = inject(TranslateService);

  languages: string[] | undefined;
  currentLanguage = 'de';

  isDropdownOpen = signal(false);

  username = this.authService.email;

  constructor() {
    this.languages = this.translate.getLangs();
    this.currentLanguage = this.translate.currentLang || 'de';
  }

  async logout() {
    this.authService.logout();
  }

  changeLanguage(): void {
    this.translate.use(this.currentLanguage);
  }
}
